export default __webpack_public_path__ + "static/1143-d50c9d573724fff6bf6fc56a1b1075ee.gif";